<div class="input-group">
  <div *appHideIfNotInRole="['vessels-crew-change-editor']">
    <button
      class="dropdown-toggle ms-1"
      mat-stroked-button
      type="button"
      id="addButtonGroup"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      Add
    </button>

    <ul class="dropdown-menu mat-elevation-z4 p-2">
      <li>
        <a class="dropdown-item" (click)="addCrew()">Crew</a>
      </li>
      <!-- <li>
        <a class="dropdown-item" (click)="addAppraisal()">Appraisal</a>
      </li> -->
    </ul>
  </div>

  <div>
    <button
      mat-stroked-button
      class="dropdown-toggle ms-1"
      type="button"
      id="downloadButtonGroup"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      Download
    </button>

    <ul class="dropdown-menu" aria-labelledby="downloadButtonGroup">
      <li>
        <a class="dropdown-item" (click)="downloadCrew()">Crew</a>
      </li>
      <!--      <li><a class="dropdown-item" (click)="downloadLatestStatusCrew()">Latest Crew Changes</a></li>-->
      <li>
        <a class="dropdown-item" (click)="downloadAllCrewChanges()">All Crew
          Changes</a>
      </li>
    </ul>
  </div>
</div>